<script lang="ts">
  import { Image } from "sveltestrap";
  import Link from "svelte-link";
  import { href } from "../../../../utils/Constant/Constant";
  let imgPath:string = "/assets/images";
  export let productItem
</script>
<td>
    <Image fluid class="img-40" src="{imgPath}/{productItem.img}" alt="#" />
</td>
<td>
    <div class="product-name">
        <Link {href}>{productItem.name}</Link>
    </div>
</td>